import Tree from 'rc-tree';
import type { EventDataNode } from 'rc-tree/lib/interface';
import React, { type Key, useState } from 'react';

import { ReactComponent as ThinArrowIcon } from '@assets/svg/thin-arrow.svg';

import type { ILocationStructureNode } from '@model/structureData';

import {
  selectAllFacilitiesChecked,
  selectSubscrLocations,
  useSubscriptionsUserActions,
} from '../../store/useSubscriptionsUserStore';
import style from './style.module.scss';

interface IProps {
  locations?: ILocationStructureNode[];
}

interface ITreeSelectedInfo {
  event: 'select';
  selected: boolean;
  node: EventDataNode<ILocationStructureNode>;
  selectedNodes: ILocationStructureNode[];
  nativeEvent: MouseEvent;
}

const LocationSelectBlock: React.FC<IProps> = ({ locations }) => {
  const { setSubscrLocations } = useSubscriptionsUserActions();

  const [expandedKeys, setExpandedKeys] = useState<Key[]>([]);

  const userLocations: Array<number> = selectSubscrLocations();
  const allFacilitiesChecked = selectAllFacilitiesChecked();

  const onSelect = (selectedNodes: React.Key[], info: ITreeSelectedInfo) => {
    setSubscrLocations(selectedNodes, info.node.parentsIds, info.node);
  };

  return (
    <div className={style.selectBlock}>
      <Tree
        className={style.selectTree}
        treeData={locations}
        selectedKeys={userLocations}
        checkedKeys={userLocations}
        fieldNames={{
          children: 'children',
          title: 'name',
          key: 'id',
        }}
        showIcon={false}
        showLine={false}
        selectable={!allFacilitiesChecked}
        checkable={!!allFacilitiesChecked}
        disabled={!!allFacilitiesChecked}
        switcherIcon={<ThinArrowIcon />}
        expandedKeys={expandedKeys}
        onExpand={setExpandedKeys}
        onSelect={(selectedNodes, info) => onSelect(selectedNodes, info)}
        titleRender={(node) => {
          if (node.levelName === 'facility') {
            return node.name;
          }

          return (
            <span className={style.locationContainer}>
              {node.name}{' '}
              <span className={style.facilityName}>{node.facilityName || node.facility?.name || ''}</span>
            </span>
          );
        }}
      />
    </div>
  );
};

export default LocationSelectBlock;
